import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { validateRedirectUrl } from '../common/utils/utils';

export default function AuthCallback() {
  const { user, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect');

  const cleanupUrl = () => {
    history.replaceState({}, document.title, '/auth/callback');
  };

  useEffect(() => {
    // Once we have a user (auth successful), redirect to onboarding
    // This callback is only used for email verification after signup
    if (!loading && user) {
      cleanupUrl();

      // Store redirect in sessionStorage if present and valid
      const validRedirect = validateRedirectUrl(redirect);
      if (validRedirect) {
        sessionStorage.setItem('postAuthRedirect', validRedirect);
      }

      const isMobile = /iphone|ipad|ipod|android/i.test(navigator.userAgent);
      if (!isMobile) {
        window.location.replace('/onboarding?slug=industry');
      }
      // For mobile, stay on this page (could show "Open app" button if needed)
    }
  }, [user, loading, redirect]);

  return <p>Verified!</p>;
}
